import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { from, lastValueFrom, Observable } from 'rxjs';
import { UsuarioDetalhado } from '../../models/UsuarioDetalhado';
import axiosClient from '../../../shared/axios/axios-client';

@Injectable({
  providedIn: 'root',
})
export class UsuariosService {
  private apiUrl = environment.apiUrl;

  async buscarUsuariosPorEmpresasEGrupos(
    empresas: number[] | null,
    grupos: number[] | null
  ): Promise<UsuarioDetalhado[]> {
    let params: string[] = [];

    if (empresas !== null) {
      params.push(`empresas=${empresas.join(',')}`);
    } else {
      params.push(`empresas=`);
    }

    if (grupos !== null) {
      params.push(`grupos=${grupos.join(',')}`);
    } else {
      params.push(`grupos=`);
    }

    const queryString = params.join('&');
    const url = `${this.apiUrl}/usuarios/filtro?${queryString}`;

    try {
      const res = await axiosClient.get<UsuarioDetalhado[]>(url);
      return res.data;
    } catch (err: any) {
      throw err;
    }
  }

  buscarUsuariosPorId(ids: number[]): Observable<UsuarioDetalhado[]> {
    const idsParam = ids.join(',');
    const url = `${this.apiUrl}/usuarios/lista?ids=${idsParam}`;
    return from(
      axiosClient.get<UsuarioDetalhado[]>(url).then((res) => res.data)
    );
  }

  async buscarUsuarioPorId(id: number): Promise<any> {
    const url = `${this.apiUrl}/usuarios/${id}`;
    try {
      const res = await axiosClient.get<any>(url);
      return res.data;
    } catch (err: any) {
      throw err;
    }
  } 

  async salvarOuAtualizarUsuario(body: any) {
    try {
      const res = await axiosClient.post('/usuarios', {
        ...body,
        id: body.id === 0 ? null : body.id,
      });
      return res.data;
    } catch (err: any) {
      throw err;
    }
  }

  async buscarDadosDoUsuarioParaTelaDeAtualizacao(id: number) {
    try {
      return await axiosClient.get(`/usuarios/${id}/atualizar`);
    } catch (err: any) {
      throw err;
    }
  }

  async inativarUsuario(id: number) {
    try {
      return await axiosClient.put(`/usuarios/${id}/desativar`);
    } catch (err: any) {
      throw err;
    }
  }

  async ativarUsuario(id: number) {
    try {
      return await axiosClient.put(`/usuarios/${id}/ativar`);
    } catch (err: any) {
      throw err;
    }
  }
}
